// Standard library imports
import React, { useEffect, useState } from 'react';
import _ from 'lodash';

// External library imports
import { toast } from 'react-toastify';

// Internal module imports
import Typography from '../../../components/Typography/Typography';
import Table from '../../../components/Table/Table';
import { useLoader } from '../../../hooks';
import classes from '../../../styles/AllDevices.module.css';
import CreateOnboardingForm from './ModalComponent/CreateOnboardingForm';
import ModalComponent from '../../../components/ModalComponent/ModalComponent';
import { OnboardingService } from '../../../services/OnboardingService';
import { UilTrash, UilEye, UilPen } from '@iconscout/react-unicons';
import IconComponent from '../../../components/Icon/Icon';
import homeClasses from '../Home.module.css';
import DeleteModal from '../../../components/DeleteModal/DeleteModal';

const Onboarding = () => {
    const [startLoader, stopLoader] = useLoader();
    const [modal, setModal] = useState({ status: false, data: null, onlyView: false });
    const [data, setData] = useState([]);
    const [deleteModal, setDeleteModal] = useState({
        status: false,
        id: '',
    });

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        OnboardingService.GetAll(startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = ({ data }) => {
        const processed = _.get(data, ['data'], []).map((item, idx) => {
            return {
                ...item,
                sno: idx + 1,
                companyName: _.get(item, ['companyDetails', 'companyName']),
                contactName: _.get(item, ['contactDetails', 'name']),
                primaryEmail: _.get(item, ['contactDetails', 'primaryEmail']),
                status: item.status,
                action: (
                    <div className={homeClasses.ActionContainer}>
                        <div onClick={() => setModal({ status: true, data: item, onlyView: true })}>
                            <IconComponent icon={UilEye} tooltip={'View'} />
                        </div>
                        {item.status === 'Pending' && (
                            <>
                                <div onClick={() => setModal({ status: true, data: item, onlyView: false })}>
                                    <IconComponent icon={UilPen} tooltip={'Edit'} />
                                </div>
                                <div onClick={() => setDeleteModal({ status: true, id: item._id })}>
                                    <IconComponent icon={UilTrash} tooltip={'Delete'} />
                                </div>
                            </>
                        )}
                    </div>
                ),
            };
        });

        setData(processed);
    };

    const handleDelete = () => {
        OnboardingService.Delete(deleteModal.id, startLoader, handleDeleteSuccess, handleError, stopLoader);
    };

    const handleDeleteSuccess = () => {
        toast.success('Form Deleted Successfully');
        getData();
    };

    const handleError = (err) => {
        toast.error(err?.response?.data?.message);
    };

    return (
        <div className={classes.AllDevices}>
            <div className={classes.Header}>
                <div>
                    <Typography content="Onboarding Forms" />
                    <div className={classes.TableCount}>
                        Total Count :
                        <span>
                            <Typography size="14" content={data?.length} />
                        </span>
                    </div>
                </div>
                <div onClick={() => setModal({ status: true, data: null, onlyView: false })}>
                    <button type="submit" className="btn-primary" style={{ marginTop: '0' }}>
                        Add Form
                    </button>
                </div>
            </div>
            <div>
                <Table
                    head={['S.No', 'Company Name', 'Contact Name', 'Primary Email', 'Status', 'Action']}
                    keys={['sno', 'companyName', 'contactName', 'primaryEmail', 'status', 'action']}
                    data={data}
                />
            </div>

            <div>
                {modal.status && (
                    <ModalComponent isOpen={modal.status} setOpen={() => {}}>
                        <div>
                            <CreateOnboardingForm editData={modal.data} onlyView={modal?.onlyView} setModal={setModal} getData={getData} />
                        </div>
                    </ModalComponent>
                )}

                <DeleteModal
                    deletefunction={handleDelete}
                    opendeleteModal={deleteModal.status}
                    setOpenDeleteModal={(status) => setDeleteModal({ ...deleteModal, status })}
                ></DeleteModal>
            </div>
        </div>
    );
};

export default Onboarding;
